<template>
  <div>
    <h5 class="mb-4">안전이슈</h5>
    <search-nav size="mobile" @handleSearch="handleSearch">
      <search-nav-item-date label="대상기간" size="mobile"  v-model="nav.date" />
      <search-nav-item-select label="발행구분" size="mobile"  v-model="nav.occur_type" :list="nav.occur_type_list" />
    </search-nav>

    <div class="flex mb-4" style="justify-content: flex-end;">
      <vs-button class="w-1/2 px-0 mr-2" type="border" color="secondary" @click="handleClickApprovalLine">{{$t('button.결재선 지정')}}</vs-button>
      <vs-button class="w-1/2 px-0 " color="secondary" @click="handleClickRegister">신규작성</vs-button>
    </div>
    <div style="margin:0 -1.2rem;">
      <vs-table
        style="border:1px solid #cdcdcd; border-radius: 0;"
        stripe
        ref="table"
        :sst="true"
        :max-items="table.perPage"
        :data="table.list"
        noDataText="'대상기간' 을 선택하거나, 키워드 검색을 진행하여 주세요."
        @selected="handleItemClickDetail">

        <template slot="thead">
          <vs-th style="min-width:130px;"><span class="w-full text-center">No.</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">사무소명</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">발행구분</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">소속</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">발생일</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">조치일</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">작성자</span></vs-th>
          <vs-th style="min-width:130px;"><span class="w-full text-center">결재상태</span></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="text-center">{{ tr.post_id }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).field_name }}</vs-td>
            <vs-td class="text-center">{{ getOccurTypeName(getPreview(tr).occur_type) }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).company }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).occur_date }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).action_date }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).writer }}</vs-td>
            <vs-td class="text-center">{{ tr.document_status.name }}</vs-td>
          </vs-tr>

        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" @change="handleChangePage"></k-pagination>
        </div>
      </div>
    </div>

    <popup-approval-process
      :show-popup="showApprovalLinePopup"
      @closePopup="handleCloseApprovalPopup" />
  </div>
</template>

<script>
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import KPagination from '@/views/components/kPagination/kPagination'
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'

export default {
  name: 'MobilePreventionSafetyRequest',
  components: {
    PopupApprovalProcess,
    SearchNavItemSelect,
    KPagination,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNav
  },
  data () {
    return {
      // 검색 네비게이션
      nav: {
        date: ['', ''],
        keyword: '',
        company:'',
        orderTarget:'created_at',
        orderDirection:'desc',
        occur_type:'',
        occur_type_list: [
          {text:'전체선택', value:''},
          {text:'대기', value:'occur_type_1'},
          {text:'수질', value:'occur_type_2'},
          {text:'폐기물', value:'occur_type_3'},
          {text:'소음', value:'occur_type_4'},
          {text:'진동', value:'occur_type_5'},
          {text:'토양', value:'occur_type_6'},
          {text:'기타', value:'occur_type_7'},
        ],
        dateTarget:'content$preview.occur_date'
      },

      // approvalLine
      approvalLine: [],
      showApprovalLinePopup: false,
      showExcelDownload: false,
      listAll: [],

      currentPage: 1,
      lastPage: 1,

      rootPath: '', // 프로젝트의 rootPath
      postId: '',
      table: {
        list: [],
        perPage: 10,
        keyword: ''
      },
    }
  },
  created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}/${paths[3]}`
    this.loadPostList()
  },
  methods: {
    async loadPostList () {
      const projectId = this.$route.params.proj_id
      const boardId = 36
      const boardSlug = 'safety_request'
      const page = this.currentPage
      const perPage = this.perPage
      const dateTarget = []
      const dateBegin = []
      const dateEnd = []
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection
      const keyword = []

      if (this.nav.dateTarget) dateTarget.push(this.nav.dateTarget)
      if (this.nav.date[0]) dateBegin.push(this.nav.date[0])
      if (this.nav.date[1]) dateEnd.push(this.nav.date[1])
      if (this.nav.keyword) keyword.push(this.nav.keyword)
      if (this.nav.company) keyword.push(`content$preview.company*%${this.nav.company}%`)
      if (this.nav.occur_type) keyword.push(`content$preview.occur_type*${this.nav.occur_type}`)

      await this.$store.dispatch('approval/LOAD_POST_ALL', {
        boardSlug,
        projectId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd,
        orderTarget,
        orderDirection,
        keyword
      })

      const listInfo = this.$store.state.approval.postListInfo
      this.table.list = this.$store.state.approval.list
      this.currentPage = listInfo.current_page
      this.lastPage = listInfo.last_page

    },

    getPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },

    getOccurTypeName (type) {
      if (type === 'occur_type_1') return '대기'
      if (type === 'occur_type_2') return '수질'
      if (type === 'occur_type_3') return '폐기물'
      if (type === 'occur_type_4') return '소음'
      if (type === 'occur_type_5') return '진동'
      if (type === 'occur_type_6') return '토양'
      if (type === 'occur_type_7') return '기타'
      return name
    },

    handleItemClickDetail (data) {
      this.$router.push(`${this.rootPath}/prevention/safety-request/${data.post_id}`)
    },

    handleClickRegister () {
      this.$router.push(`${this.rootPath}/prevention/safety-request/create`)
    },

    handleClickApprovalLine () {
      this.showApprovalLinePopup = true
    },
    handleCloseApprovalPopup () {
      this.showApprovalLinePopup = false
    },

    handleSearch () {
      this.loadPostList()
    },

    handleChangePage (_data) {
      this.currentPage = _data
      this.handleSearch()
    }
  }
}
</script>

<style scoped>

</style>
